export default {
  methods: {
    resolveDeepProperty(propertyPath, object) {
      return propertyPath.split('.').reduce(function(prev, curr) {
        return prev ? prev[curr] : null;
      }, object || self);
    },
  },
};
